/** The book. Facts from the Palmetto metadata form, September 2026. */
export const BOOK = {
  title: 'Thinking with AI',
  subtitle: 'The Leadership Discipline for the Age of AI',
  author: 'Srini Koushik',
  publisher: 'Palmetto Publishing',
  published: '2026-09-22',
  publishedText: 'September 22, 2026',
  pages: 214,
  trim: '6 by 9 inches',
  cover: '/images/v2/book-cover-704.jpg',
  coverSmall: '/images/v2/book-cover-360.jpg',
  og: '/images/v2/og-book.jpg',
  backCoverLine: 'AI can generate answers. This book is about developing better thinkers.',
  descriptionLine: 'The machine gets smarter. This book shows you how to grow smarter with it.',
  formats: [
    { name: 'Hardcover', isbn: '9798318850349', price: '$29.99', url: 'https://www.amazon.com/dp/B0HJB65X4P' },
    { name: 'Paperback', isbn: '9798318850356', price: '$17.99', url: 'https://www.amazon.com/dp/B0HJ9XLT81' },
    { name: 'Kindle',    isbn: '9798318850363', price: '$7.99',  url: 'https://www.amazon.com/dp/B0HJB2QBMC' },
  ],
  description: [
    'You are already using AI. You have the tools, the platforms, the dashboards, and the briefings. The real opportunity is not learning how to use AI more efficiently. It is learning how to think with it more effectively.',
    'As AI becomes part of everyday work, the leaders who thrive will be the ones who strengthen the human capabilities that make judgment, creativity, collaboration, and accountability possible. The leaders who do not are sliding into the Cognitive Rust Belt, where skills atrophy one unchallenged answer at a time.',
    'Thinking with AI starts where most AI books stop: with the human. It introduces a leadership discipline for the AI era. Through the 5Cs, the Mastery Loop, and the CoThink Discipline, you learn how to amplify human potential while building a working partnership with intelligent machines.',
    'Thinking with AI is not about keeping up with machines. It is about becoming more fully human in how you think, decide, create, and lead.',
  ],
  inside: [
    { head: 'Why AI Fluency is a leadership discipline', body: 'A technical skill can be delegated. A discipline has to be practiced by the person accountable for the outcome.' },
    { head: 'The five human capabilities that gain value as AI gains capability', body: 'Conceptual Clarity, Creative Exploration, Critical Evaluation, Constructive Collaboration, and Cognitive Agility: the 5Cs.' },
    { head: 'A working way to think with AI instead of merely using it', body: 'The Mastery Loop and the CoThink Discipline, laid out so a leader can run them on real work the same week.' },
  ],
  authorBio: 'Srini Koushik has spent more than 35 years leading technology organizations at IBM, Nationwide, Magellan Health, HP, and Rackspace, through enterprise computing, the internet, cloud, data, and artificial intelligence. A two-time IBM Distinguished Engineer, CIO Hall of Fame inductee, and recipient of the Ohio CIO ORBIE Global Award, he is Founder and CEO of Right Brain Labs and Executive Advisor for AI Fluency at The Ohio State University Fisher College of Business.',
};

export const bookJsonLd = () => ({
  '@context': 'https://schema.org',
  '@type': 'Book',
  name: `${BOOK.title}: ${BOOK.subtitle}`,
  author: { '@type': 'Person', name: BOOK.author, url: 'https://www.srinikoushik.com' },
  publisher: { '@type': 'Organization', name: BOOK.publisher },
  datePublished: BOOK.published,
  numberOfPages: BOOK.pages,
  inLanguage: 'en',
  image: `https://www.rightbrainlabs.ai${BOOK.cover}`,
  workExample: BOOK.formats.map((f) => ({
    '@type': 'Book',
    isbn: f.isbn,
    bookFormat: f.name === 'Kindle' ? 'https://schema.org/EBook' : f.name === 'Hardcover' ? 'https://schema.org/Hardcover' : 'https://schema.org/Paperback',
    potentialAction: { '@type': 'ReadAction', target: { '@type': 'EntryPoint', urlTemplate: f.url } },
    offers: { '@type': 'Offer', price: f.price.replace('$', ''), priceCurrency: 'USD', url: f.url, availability: 'https://schema.org/InStock' },
  })),
});
